import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { Step } from './step';

const ProgressContainer = styled.ol`
  margin: 1em 0;
  padding: 0;
  text-align: center;
`;

const ProgressDot = styled.li`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 2px;
  background: ${({ active, theme }) => (active ? theme.colors.red : theme.colors.n700)};
`;

const Stepper = ({ children, initialStep = 0 }) => {
  return (
    <div>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, { index, isCurrent: initialStep === index }),
      )}
      <ProgressContainer>
        {React.Children.map(children, (_, index) => (
          <ProgressDot active={initialStep === index} />
        ))}
      </ProgressContainer>
    </div>
  );
};

Stepper.propTypes = {
  children: PropTypes.node,
  initialStep: PropTypes.number,
};

export default Stepper;
export { Step };
